<script>
    import { store } from '../../Store.svelte';
    import { env, principalStreamersNames } from '../../Environment.svelte';
    import { isCombo, getExtMessage } from '../../Util.svelte';
    import { servicePaymentPeriodMessages } from '../../data/extMessages';

    export let item = {};
    export let isSelected = null;
    export let isDisable = null;
    export let isNetflix = null;
    export let netflixM = null;
    export let isHazloHDPlus = null;
    export let isPrincipal = null;
    export let logoPrincipal = null;

    const netflix1SName = principalStreamersNames.at(5);
    const netflix2SName = principalStreamersNames.at(1);
    const netflix4SName = principalStreamersNames.at(2);
    const netflixAdds = principalStreamersNames.at(6);
    const disneyPlusEstandar = 'Disney+ Estandar M';
    const disneyPlusPremium = 'Disney+ Premium M';
    const hazloMaxEstandar = 'Hazlo estandar para Max basico M';
    const maxBasicoConAnunciosM = 'Max basico con anuncios M';
    const hazloMaxEstandarLineales =
        'Hazlo estandar para Max basico (Lineales) M';

    let checked = false;
    let isVisible = true;
    let requeridos = [];
    let disabled = false;
    let plan = '';
    let descripcion = '';
    let precio = '';
    let precio1S;
    let precio2S;
    let precio4S;
    let precioAdd;
    let selectedNetflix;
    let isNetflixInCombo =
        $store.requestedServices.isCombo && $store.requestedServices.isNetflix;

    store.subscribe((value) => {
        let shouldBeChecked = false;
        let requeridosCantidad = 0;
        let principales = 0;
        let netflix = '';
        $store.requestedServices.channelExtras.forEach((extra) => {
            const { extName, cost, opcionesModular } = extra.extra;
            if (extra.extId == item.extId) {
                shouldBeChecked = extra.nuevaCantidad > 0;
            }
            if (extra.combo) {
                if (extName.startsWith('Netflix')) {
                    netflix = extra.extra.extName;
                    let discount = opcionesModular[0].monto;
                    selectedNetflix = cost - discount;
                }
                principales++;
            }
        });

        $store.requestedServices.product?.extrasMap.ott.forEach((extra) => {
            const { extName, promoCost, cost, opcionesModular } = extra.extra;
            if (
                extName == netflix1SName ||
                extName == netflix2SName ||
                extName == netflix4SName ||
                extName == netflixAdds
            ) {
                let extraNetflixCost = isNetflixInCombo ? promoCost : cost;
                let extraNetflixDiscount = opcionesModular[0].monto;

                if (extName == netflix1SName)
                    precio1S = extraNetflixCost - extraNetflixDiscount;
                if (extName == netflix2SName)
                    precio2S = extraNetflixCost - extraNetflixDiscount;
                if (extName == netflix4SName)
                    precio4S = extraNetflixCost - extraNetflixDiscount;
                if (extName == netflixAdds)
                    precioAdd = extraNetflixCost - extraNetflixDiscount;
            }
        });

        if (requeridos.length > 0) {
            requeridosCantidad = requeridos.filter((element) =>
                $store.requestedServices.channelExtras.find(
                    (ce) => ce.extId == element.extId
                )
            ).length;
            if (requeridos.length === requeridosCantidad) {
                isVisible = true;
            } else {
                isVisible = false;
            }
        }

        checked = shouldBeChecked;

        if (isPrincipal) {
            if (item.extra.extName.startsWith('Netflix')) {
                checked = checked && $store.requestedServices.isNetflix;
            } else {
                if (
                    item.extra.extName === principalStreamersNames.at(4) ||
                    item.extra.extName === principalStreamersNames.at(7)
                ) {
                    checked = checked && $store.requestedServices.isHBO;
                }
            }
        } else {
            if ($store.requestedServices.isNetflix) {
                switch (item.extra.extName) {
                    case netflix1SName:
                        let resultado1S = precio1S - selectedNetflix;
                        plan = 'Plan básico';
                        descripcion = '1 Pantalla HD';
                        precio =
                            resultado1S < 0 ? resultado1S : `+${resultado1S}`;
                        break;
                    case netflix2SName:
                        let resultado2S = precio2S - selectedNetflix;
                        plan = 'Plan estándar';
                        descripcion = '2 Pantallas Full HD';
                        precio =
                            resultado2S < 0 ? resultado2S : `+${resultado2S}`;
                        break;
                    case netflix4SName:
                        let resultado4S = precio4S - selectedNetflix;
                        plan = 'Plan premium';
                        descripcion = '4 Pantallas 4K +HDR';
                        precio =
                            resultado4S < 0 ? resultado4S : `+${resultado4S}`;
                        break;
                    case netflixAdds:
                        let resultado = precioAdd - selectedNetflix;
                        plan = 'Plan estándar con anuncios';
                        descripcion = '2 Pantalla HD';
                        precio = resultado < 0 ? resultado : `+${resultado}`;
                        break;
                    default:
                        break;
                }
            }
        }

        if (isPrincipal) {
            disabled =
                !checked &&
                ($store.requestedServices.isCombo
                    ? value.requestedServices.product.vel > 90
                        ? principales >= 3
                        : principales >= 2
                    : true);
        }

        if (item.extra.extName === 'Combo+ bundle D+ Promo anual') {
            isVisible = false;
        }

        if (!isVisible) {
            let itemRemove = $store.requestedServices.channelExtras.find(
                (extra) => extra.extra.extName == item.extra.extName
            );
            if (itemRemove) {
                $store.requestedServices.channelExtras =
                    $store.requestedServices.channelExtras.filter((extra) =>
                        removeCurrentExtra(extra, itemRemove)
                    );
            }
        }
    });

    function onclick() {
        if (checked) {
            addItem($store.requestedServices.channelExtras, item);
        } else {
            $store.requestedServices.channelExtras =
                $store.requestedServices.channelExtras.filter((extra) =>
                    removeCurrentExtra(extra, item)
                );
            if (isNetflix === 'true')
                addItem($store.requestedServices.channelExtras, netflixM);
        }
    }

    function addVix() {
        let vixM = $store.requestedServices.product.extrasMap.ott.find(
            (extra) =>
                extra.extra.extName == principalStreamersNames.at(0) &&
                extra.paqextVisible
        );
        if (vixM) addItem($store.requestedServices.channelExtras, vixM);
    }

    function addItem(selectedExtras, itemTemp) {
        // let omitir = $store.requestedServices.product.productFamily === "residencial" && $store.requestedServices.product.vel < 100;
        if (
            selectedExtras.find((e) => {
                return e.extId === itemTemp.extId;
            }) == undefined
        ) {
            const {
                title,
                extGrupo,
                extName,
                opcionesModular,
                descriptionOTT,
                promoItem,
                promoCost,
                cost,
            } = itemTemp.extra;
            let costToApply =
                extName === principalStreamersNames.at(0) &&
                !$store.requestedServices.isVix &&
                promoItem != null &&
                promoItem.precio != null
                    ? promoItem.precio
                    : isNetflixInCombo &&
                        title.includes('Netflix') &&
                        promoCost != null
                      ? promoCost
                      : cost;
            selectedExtras.push({
                extId: itemTemp.extId,
                nuevaCantidad: 1,
                extra: {
                    title: title,
                    cost: costToApply,
                    extGrupo: extGrupo,
                    extName: extName,
                    opcionesModular: opcionesModular,
                    descriptionOTT: descriptionOTT,
                },
                combo: isCombo(itemTemp, $store, 'addItem'),
            });
        }
        $store.requestedServices.channelExtras = selectedExtras.filter(
            (extra) => removeInvalidExtras(extra, itemTemp)
        );
    }

    function removeInvalidExtras(extra, itemTemp) {
        let invalid = false;
        if (itemTemp.extra.extEliminar != null) {
            itemTemp.extra.extEliminar.forEach((invalidId) => {
                if (invalidId == extra.extId) {
                    invalid = true;
                }
            });
        }
        if (itemTemp.extra.extGrupo != null) {
            if (
                extra.extra.extGrupo === itemTemp.extra.extGrupo &&
                itemTemp.extId != extra.extId
            ) {
                invalid = true;
            }
        }
        return !invalid;
    }

    function removeCurrentExtra(extra, itemTemp) {
        return extra.extId != itemTemp.extId;
    }

    var offerClass = '';
    var logo = item.extra.logo;
    if (item.extra.addonClass != null) {
        offerClass = item.extra.addonClass;
    } else {
        offerClass = env.classesAddOns[item.extra.title];
        offerClass =
            offerClass === null || offerClass === undefined ? '' : offerClass;
    }

    if (logo == null) {
        logo = env.logosAddOns[item.extra.title];
    }

    if (isSelected == 'true') {
        checked = true;
        onclick();
    }

    if (item.extra.extRequired != null && item.extra.extRequired.length > 0) {
        pushElement(
            includesRequired(
                $store.requestedServices.product.extrasMap.canalesPremium,
                item.extra.extRequired
            )
        );
        pushElement(
            includesRequired(
                $store.requestedServices.product.extrasMap.ott,
                item.extra.extRequired
            )
        );
        pushElement(
            includesRequired(
                $store.requestedServices.product.extrasMap.canalesCarta,
                item.extra.extRequired
            )
        );
        if (requeridos.length > 0) {
            isVisible = false;
        }
    }

    function pushElement(arrayItems) {
        arrayItems.forEach((arrayItem) => {
            if (!requeridos.find((i) => i.extId == arrayItem.extId)) {
                if (!arrayItem.paqextDefault) requeridos.push(arrayItem);
            }
        });
    }

    function includesRequired(arrayItems, elementsRequired) {
        return arrayItems.filter((i) =>
            elementsRequired.includes(i.extId.toString())
        );
    }

    function addPrincipal(event) {
        if (!event.target.checked) {
            $store.requestedServices.channelExtras =
                $store.requestedServices.channelExtras.filter((extra) =>
                    removeCurrentExtra(extra, item)
                );
        }
        if (event.target.name.startsWith('Netflix')) {
            $store.requestedServices.isNetflix = event.target.checked;
        } else {
            if (
                event.target.name === principalStreamersNames.at(4) ||
                event.target.name === principalStreamersNames.at(7)
            ) {
                $store.requestedServices.isHBO = event.target.checked;
            }
        }
        onclick();
    }

    var ga4ID = `addon-item-${item.extra.extName?.toLowerCase().replace(" ", "-").replace("+", "plus")}-ga4`;
</script>

{#if isDisable === 'false'}
    {#if isPrincipal !== 'true'}
        {#if isNetflix !== 'true' && isHazloHDPlus !== 'true' && isVisible}
            <div class="addon {offerClass}">
                <input
                    type="checkbox"
                    name=""
                    id="addon_{item.extId}"
                    bind:checked
                    on:change={onclick}
                />
                <label for="addon_{item.extId}" id="{ga4ID}" class="addon-label">
                    <span class="addon-check__indicator"
                        ><img
                            src="/assets/img/icons/check.svg"
                            alt=""
                            aria-hidden="true"
                        /></span
                    >
                    <div class="addon-name">
                        {#if logo != null && logo != undefined}
                            <img src={logo} alt={item.extra.title} />
                        {:else}
                            <p>{item.extra.title}</p>
                        {/if}
                    </div>
                    <div class="addon-description">
                        {#if [netflix1SName, netflix2SName, netflix4SName, netflixAdds].includes(item.extra.extName) && $store.requestedServices.isNetflix}
                            <p class="text-fs-13">{plan}</p>
                            <p>{descripcion}</p>
                        {:else if [disneyPlusEstandar, disneyPlusPremium, hazloMaxEstandar, hazloMaxEstandarLineales, maxBasicoConAnunciosM].includes(item.extra.extName)}
                            <p class="text-fs-12">{item.extra.title}</p>
                        {:else if item.extra.promoItem != null}
                            <p>{item.extra.promoItem.descripcion}</p>
                        {/if}
                    </div>
                    <div class="addon-pricing">
                        {#if [netflix1SName, netflix2SName, netflix4SName, netflixAdds].includes(item.extra.extName) && $store.requestedServices.isNetflix}
                            <p class="fw-semibold">
                                <span class="addon-price">{precio}</span>
                            </p>
                        {:else}
                            <p class="fw-semibold">
                                +$<span class="addon-price"
                                    >{item.extra.cost}</span
                                >
                            </p>
                        {/if}
                        <p class="small-text">
                            {#if getExtMessage(item.extra.extName, servicePaymentPeriodMessages)}
                                {getExtMessage(
                                    item.extra.extName,
                                    servicePaymentPeriodMessages
                                )}
                            {:else}
                                al mes
                            {/if}
                        </p>
                    </div>
                </label>
            </div>
        {/if}
        {#if isNetflix === 'true'}
            <div class="labels-holder m-b-25">
                <div class="label__selectable_wrapper m-b-10">
                    <input
                        type="checkbox"
                        id="netflix_4pantallas"
                        name="netflix_4pantallas"
                        bind:checked
                        on:change={onclick}
                    />
                    <label for="netflix_4pantallas" id="netflix_4pantallas_ga4" class="label__selectable">
                        <span class="label__selectable__indicator"
                            ><img
                                src="/assets/img/icons/check.svg"
                                alt=""
                                aria-hidden="true"
                            /></span
                        >
                        <div class="label__description">
                            <img
                                class="m-b-15"
                                src="/assets/img/dummy-img/logos/netflix-logo.svg"
                                alt="Netflix"
                            />
                            <p class="fw-semibold">+4 pantallas Ultra HD</p>
                            <p class="m-b-10">
                                Agrega más pantallas Netflix Premium
                            </p>
                            <div class="h2 text-fs-20 fw-semibold">
                                <span class="primary-text">+$80</span>
                                <span class="text-fs-15 fw-regular">al mes</span
                                >
                            </div>
                        </div>
                        <div class="label__action pure__button">
                            <span class="on-uncheck">Agregar</span><span
                                class="on-check">Quitar</span
                            >
                        </div>
                    </label>
                </div>
            </div>
        {/if}
        {#if isHazloHDPlus === 'true'}
            <div class="labels-holder m-b-25">
                <div class="label__selectable_wrapper m-b-10">
                    <input
                        type="checkbox"
                        id="hazlohdplus"
                        name="hazlohdplus"
                        value=""
                        bind:checked
                        on:change={onclick}
                    />
                    <label for="hazlohdplus" id="hazlohdplus_ga4" class="label__selectable">
                        <span class="label__selectable__indicator"
                            ><img
                                src="/assets/img/icons/check.svg"
                                alt=""
                                aria-hidden="true"
                            /></span
                        >
                        <div class="label__description">
                            <p class="fw-semibold">Hazlo HD Plus</p>
                            <p class="m-b-10">
                                Agrega más canales a tu paquete <br />Obtén 200
                                canales (85 en HD)
                            </p>
                            <div class="h2 text-fs-20 fw-semibold">
                                <span class="primary-text"
                                    >+${item.extra.cost}</span
                                >
                                <span class="text-fs-15 fw-regular">al mes</span
                                >
                            </div>
                        </div>
                        <div class="label__action pure__button">
                            <span class="on-uncheck">Agregar</span><span
                                class="on-check">Quitar</span
                            >
                        </div>
                    </label>
                </div>
            </div>
        {/if}
    {:else}
        <div class="addon izzicombo-addon {offerClass}">
            <input
                type="checkbox"
                name={item.extra.extName}
                id="addon_p_{item.extId}"
                bind:checked
                on:change={addPrincipal}
                {disabled}
            />
            <label for="addon_p_{item.extId}" class="addon-label">
                <span class="addon-check__indicator"
                    ><img
                        src="/assets/img/icons/check.svg"
                        alt=""
                        aria-hidden="true"
                    /></span
                >
                <div class="addon-name">
                    <img src={logoPrincipal} alt="" />
                </div>
            </label>
        </div>
    {/if}
{/if}
